import React, { useState, useEffect, useContext } from 'react';
import axios from 'axios';
import { apiRoutes } from '../../../AppSettings';
import PatientInfo from './PatientInfo';
import { AuthContext } from '../../../contexts/AuthContext';
import Util from '../../../Util';
import { Link } from 'react-router-dom';

const ViewPrescription = React.forwardRef((props, ref) => {
    const doctor = props.doctor;
	const patient = props.patient;
	const prescriptionId = props.prescriptionId;

    const { userState } = useContext(AuthContext);
    const [prescriptions, setPrescriptions] = useState({});

	const options = {
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'bearer '+ userState.token
        }
	};

    useEffect(() => {
        axios.get(apiRoutes.getPrescriptionById + prescriptionId, options)
        .then((response) => {
          if(response.status === 200)
          {
              const data = response.data;
              console.log(data);
              setPrescriptions(data);
          }
        }, (error) => {
          console.log(error);
      });
    }, [])

    return ( 
            <div id="printarea" className="card" ref={ref}>
                <div className="card-header">
                    <h4 className="card-title mb-0">View Prescription</h4>
                </div>
                <div className="card-body">
                    <div className="row">
                        <div className="col-sm-6">
                            <div className="biller-info">
                                <h4 className="d-block">Dr. {doctor.firstName} {doctor.lastName}</h4>
                                <span className="d-block text-sm text-muted">{doctor.category}</span>
                                <span className="d-block text-sm text-muted">{doctor.state}, {doctor.country}</span>
                            </div>
                        </div>
                        <div className="col-sm-6 text-sm-right">
                            <div className="billing-info">
                                <h4 className="d-block">{Util.getFormatDate({date: (new Date())})}</h4>
                                <span className="d-block text-muted">
                                </span>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-sm-6">
                            <div className="form-group">
                                <label>Prescription Name: </label>
                                <label>&nbsp;{prescriptions.name} </label>
                            </div>
                        </div>
                        <div className="col-sm-6 text-sm-right">
                            <div className="form-group">
                                <label>Appoinment: </label>
                                <label>&nbsp; {prescriptions.appoinment != undefined && prescriptions.appoinment.appoinmentNumber} </label>
                            </div>
                        </div>
                    </div>
                    <div className="card card-table">
                        <div className="card-body">
                            <div className="table-responsive">
                                <table className="table table-hover table-center">
                                    <thead>
                                        <tr>
                                            <th style={{minWidth: "200px"}}>Name</th>
                                            <th style={{minWidth: "80px"}}>Quantity</th>
                                            <th style={{minWidth: "80px"}}>Days</th>
                                            <th style={{minWidth: "100px"}}>Time</th>
                                            <th style={{minWidth: "80px"}}></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            prescriptions != undefined && prescriptions.prescriptionItem != undefined &&
                                            prescriptions.prescriptionItem.map(item => (
                                                <tr key={item.id}>
                                                    <td>
                                                        {item.name}
                                                    </td>
                                                    <td>
                                                        {item.quantity}
                                                    </td>
                                                    <td>
                                                        {item.days}
                                                    </td>
                                                    <td>
                                                        <div className="form-check form-check-inline">
                                                            <label className="form-check-label">
                                                                <input className="form-check-input" type="checkbox" disabled checked={item.morning} /> Morning
                                                            </label>
                                                        </div>
                                                        <div className="form-check form-check-inline">
                                                            <label className="form-check-label">
                                                                <input className="form-check-input" type="checkbox" disabled checked={item.afternoon} /> Afternoon
                                                            </label>
                                                        </div>
                                                        <div className="form-check form-check-inline">
                                                            <label className="form-check-label">
                                                                <input className="form-check-input" type="checkbox" disabled checked={item.evening} /> Evening
                                                            </label>
                                                        </div>
                                                        <div className="form-check form-check-inline">
                                                            <label className="form-check-label">
                                                                <input className="form-check-input" type="checkbox" disabled checked={item.night} /> Night
                                                            </label>
                                                        </div>
                                                    </td>
                                                    <td>
                                                    </td>
                                                </tr>
                                            ))
                                        }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>

                    {
                        prescriptions != undefined && prescriptions.prescriptionService != undefined && prescriptions.prescriptionService.length > 0  && 
                        <div className="card card-table">
                            <div className="card-header">
                                <h4 className="card-title mb-0">Services</h4>
                            </div>
                            <div className="card-body">
                                <div className="table-responsive">
                                    <table className="table table-hover table-center">
                                        <thead>
                                            <tr>
                                                <th style={{minWidth: "100px"}}>Name</th>
                                                <th style={{minWidth: "100px"}}>Description</th>
                                                <th style={{minWidth: "80px"}}></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                prescriptions != undefined && prescriptions.prescriptionService != undefined &&
                                                prescriptions.prescriptionService.map(item => (
                                                    <tr key={item.prescriptionServiceId}>
                                                        <td>
                                                            {item.serviceName}
                                                        </td>
                                                        <td>
                                                            {item.description}
                                                        </td>
                                                        <td>
                                                        </td>
                                                    </tr>
                                                ))
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    }

                    <div className="row">
                        <div className="col-md-12 text-right">
                            <div className="signature-wrap">
                                <div className="signature">
                                    {doctor.firstName} {doctor.lastName}
                                </div>
                                <div className="sign-name">
                                    <p className="mb-0">( Dr. {doctor.firstName} {doctor.lastName} )</p>
                                    <span className="text-muted">Signature</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12">
                            
                        </div>
                    </div>
                </div>
            </div>
    );
})
 
export default ViewPrescription;